export function getEnvironmentVariable(envVarName: string): string | null {
  const envValue = import.meta.env[envVarName];
  return envValue || null;
}